import RestService from '../RestService';

import * as React from 'react';

interface Props {
    history?: any;
}

interface State {
    loggedOut?: boolean;
}

class LogoutComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        console.log('componentDidMount');
        const loggedOut = RestService.logout();
        this.setState({
            loggedOut: loggedOut,
        });

        if (loggedOut) {
            this.props.history.push('/login');
        }
    }

    render() {
        return (
            this.state.loggedOut ?
                <h1>Logged out successfully</h1> 
                : <h1>Error occurred while logging you out...</h1>
        );
    }
}

export default LogoutComponent;


// WEBPACK FOOTER //
// ./src/components/Logout.tsx